<template>
  <div class="classic-works">
    <h1 class="section-title">经典书法作品</h1>
    
    <div class="works-gallery">
      <!-- 兰亭序 -->
      <div class="work-item">
        <div class="work-image">
          <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=chinese%20calligraphy%20lanting%20preface&image_size=landscape_4_3" alt="兰亭序">
        </div>
        <div class="work-info">
          <h3>兰亭序</h3>
          <p class="work-author">王羲之</p>
          <p class="work-period">东晋</p>
          <p class="work-description">天下第一行书，笔法精妙，结构天成。</p>
        </div>
      </div>
      
      <!-- 祭侄文稿 -->
      <div class="work-item">
        <div class="work-image">
          <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=chinese%20calligraphy%20yan%20zhenqing&image_size=landscape_4_3" alt="祭侄文稿">
        </div>
        <div class="work-info">
          <h3>祭侄文稿</h3>
          <p class="work-author">颜真卿</p>
          <p class="work-period">唐代</p>
          <p class="work-description">天下第二行书，笔法凝重，情感真挚。</p>
        </div>
      </div>
      
      <!-- 寒食帖 -->
      <div class="work-item">
        <div class="work-image">
          <img src="https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=chinese%20calligraphy%20su%20shi&image_size=landscape_4_3" alt="寒食帖">
        </div>
        <div class="work-info">
          <h3>寒食帖</h3>
          <p class="work-author">苏轼</p>
          <p class="work-period">宋代</p>
          <p class="work-description">天下第三行书，笔法自然流畅，意境深远。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClassicWorks'
}
</script>

<style scoped>
.classic-works {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.section-title {
  font-size: 2.5em;
  color: #333;
  text-align: center;
  margin-bottom: 60px;
  font-family: 'SimSun', serif;
}

.works-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
}

.work-item {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.3s ease;
}

.work-item:hover {
  transform: translateY(-5px);
}

.work-image {
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.work-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.work-info {
  padding: 20px;
}

.work-info h3 {
  font-size: 1.3em;
  color: #333;
  margin-bottom: 10px;
  font-family: 'SimSun', serif;
}

.work-author {
  font-size: 0.9em;
  color: #666;
  margin-bottom: 5px;
}

.work-period {
  font-size: 0.9em;
  color: #999;
  margin-bottom: 15px;
}

.work-description {
  color: #666;
  line-height: 1.5;
  font-size: 0.95em;
}
</style>